import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "card-body card-body-custom-layout" }
const _hoisted_9 = {
  key: 0,
  class: "legacy-info-bar mx-3 mt-2 mb-1 p-3 d-flex align-items-start gap-2",
  role: "alert"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-warning alert-dismissible fade show mb-0 flex-grow-1 ms-2 mb-2 fortnox-company-alert",
  role: "alert",
  style: {"font-size":"small","padding":"0.5rem 0rem 0rem 0rem","margin-right":"10px"}
}
const _hoisted_13 = { class: "fortnox-card-body-grid" }
const _hoisted_14 = {
  key: 0,
  class: "fas fa-check text-green"
}
const _hoisted_15 = {
  key: 1,
  class: "fas fa-times-circle text-gray"
}
const _hoisted_16 = {
  key: 0,
  class: "fas fa-check text-green"
}
const _hoisted_17 = {
  key: 1,
  class: "fas fa-times-circle text-yellow"
}
const _hoisted_18 = {
  class: "btn-group actions-row d-inline-flex align-items-center actions-row gap-2",
  role: "group",
  "aria-label": "Row actions"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "modal fade",
  id: "companyModal",
  role: "dialog"
}
const _hoisted_24 = { class: "modal-dialog modal-lg" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = { class: "modal-title" }
const _hoisted_27 = { class: "modal-body" }
const _hoisted_28 = {
  key: 0,
  class: "row"
}
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "icheck-primary" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  key: 0,
  class: "col"
}
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "icheck-success" }
const _hoisted_41 = { class: "form-row" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = { class: "col-12 tree-view-container" }
const _hoisted_44 = { class: "modal-footer" }
const _hoisted_45 = {
  type: "submit",
  class: "btn btn-sm btn-outline-info-reverse"
}
const _hoisted_46 = {
  class: "modal fade",
  id: "force-sync-modal",
  role: "dialog"
}
const _hoisted_47 = { class: "modal-dialog modal-xs" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = { class: "modal-header" }
const _hoisted_50 = { class: "modal-body" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-md-12" }
const _hoisted_53 = { class: "mb-2" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "mb-2" }
const _hoisted_57 = { class: "col" }
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = { class: "mb-2" }
const _hoisted_60 = { class: "col" }
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = { class: "mb-2" }
const _hoisted_63 = { class: "col" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = { class: "mb-2" }
const _hoisted_66 = { class: "col" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = {
  for: "entities",
  class: "form-label"
}
const _hoisted_69 = { class: "modal-footer" }
const _hoisted_70 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!
  const _component_ejs_dropdownlist = _resolveComponent("ejs-dropdownlist")!
  const _component_ejs_textbox = _resolveComponent("ejs-textbox")!
  const _component_CustomTreeView = _resolveComponent("CustomTreeView")!
  const _component_ejs_radiobutton = _resolveComponent("ejs-radiobutton")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_ejs_checkbox = _resolveComponent("ejs-checkbox")!
  const _component_ejs_multiselect = _resolveComponent("ejs-multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                class: "btn btn-outline-primary btn-sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open()))
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-plus" }, null, -1)),
                _createTextVNode("  " + _toDisplayString(_ctx.$t("addNew")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.hasLegacyCompanies)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "fas fa-info-circle legacy-info-icon mt-1 flex-shrink-0" }, null, -1),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, "Authentication Update Required"),
                  _createElementVNode("p", {
                    class: "mb-1 mt-1",
                    style: {"font-size":"0.85rem"}
                  }, " We're improving the way Fortnox data is synchronized by introducing a more convenient and secure authentication method. As part of this update, we're moving away from the previous token-based login. "),
                  _createElementVNode("p", {
                    class: "mb-1",
                    style: {"font-size":"0.85rem"}
                  }, [
                    _createTextVNode(" To continue using the integration, you'll need to "),
                    _createElementVNode("strong", null, "re-authorize your Fortnox connection"),
                    _createTextVNode(" and generate new tokens. ")
                  ]),
                  _createElementVNode("p", {
                    class: "mb-0",
                    style: {"font-size":"0.85rem"}
                  }, " If you need any help with the process, feel free to reach out. ")
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.alert.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alert.messages, (msg, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(msg), 1))
                      }), 128))
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      "data-bs-dismiss": "alert",
                      "aria-label": "Close"
                    }, [
                      _createElementVNode("span", { "aria-hidden": "true" }, "×")
                    ], -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_ejs_grid, {
              ref: "gridCompany",
              dataSource: _ctx.data,
              allowPaging: true,
              allowResizing: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 30,
              allowSorting: true,
              searchSettings: _ctx.searchOptions,
              dataStateChange: _ctx.dataStateChange,
              commandClick: _ctx.commandClick,
              height: '100%',
              width: '100%',
              allowScrolling: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('legalEntity'),
                      field: "legalEntityName",
                      freeze: "Left"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('name'),
                      field: "Name",
                      freeze: "Left"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('fortnoxName'),
                      field: "fortnoxName"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('creationTime'),
                      field: "CreationTime",
                      type: "date",
                      format: "yyyy-MM-dd hh:mm a",
                      template: 'creationTimeTemplate'
                    }, {
                      creationTimeTemplate: _withCtx(({ data }) => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getRelativeSwedishDatetime(data.creationTime)), 1)
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('refreshTokenExpiryDate'),
                      field: "RefreshTokenExpireDate",
                      type: "date",
                      format: "yyyy-MM-dd hh:mm a",
                      template: 'refreshTokenExpireDateTemplate'
                    }, {
                      refreshTokenExpireDateTemplate: _withCtx(({ data }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(`expire-date badge ${data.isRefreshTokenExpire ? 'badge-danger' : 'badge-success'}`)
                        }, _toDisplayString(_ctx.getRelativeSwedishDatetime(data.refreshTokenExpireDate)), 3)
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('lastSynced'),
                      field: "LastSyncDate",
                      type: "date",
                      format: "yyyy-MM-dd hh:mm a",
                      template: 'lastSyncedDateTemplate'
                    }, {
                      lastSyncedDateTemplate: _withCtx(({ data }) => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getRelativeSwedishDatetime(data.lastSyncDate)), 1)
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('syncEnabled'),
                      field: "DoSync",
                      type: "boolean",
                      template: 'doSyncTemplate',
                      "text-align": "Center"
                    }, {
                      doSyncTemplate: _withCtx(({ data }) => [
                        _createElementVNode("span", null, [
                          (data && data.doSync)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                            : (_openBlock(), _createElementBlock("i", _hoisted_15))
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('scopeChangeApplied'),
                      field: "isScopeChangeApplied",
                      type: "boolean",
                      template: 'scopeChangeTemplate',
                      "text-align": "Center"
                    }, {
                      scopeChangeTemplate: _withCtx(({ data }) => [
                        _createElementVNode("span", null, [
                          (data && data.isScopeChangeApplied)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                            : (_openBlock(), _createElementBlock("i", _hoisted_17))
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('actions'),
                      width: "300",
                      textAlign: "Center",
                      freeze: "Right",
                      template: 'commandsTemplate'
                    }, {
                      commandsTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "action-link action-edit",
                            title: "Edit",
                            onClick: ($event: any) => (_ctx.onEditButtonClick(data))
                          }, [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "e-edit e-icons" }, null, -1)
                          ]))], 8, _hoisted_19),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "action-link action-delete",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.onDeleteButtonClick(data))
                          }, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("i", {
                              class: "e-delete e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_20),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "action-link action-add",
                            title: "Force Fortnox Sync",
                            onClick: ($event: any) => (_ctx.onForceSyncButtonClick(data))
                          }, [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "e-repeat e-icons" }, null, -1)
                          ]))], 8, _hoisted_21),
                          _createElementVNode("button", {
                            class: _normalizeClass([(data.isRefreshTokenExpire || data.isTokenMissing) ? 'e-danger' : !data.isScopeChangeApplied ? 'e-warning' : 'e-success', "e-btn e-small"]),
                            title: "Authenticate Fortnox",
                            onClick: ($event: any) => (_ctx.onActivateFortnoxButtonClick(data))
                          }, " Authenticate ", 10, _hoisted_22)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "dataStateChange", "commandClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(), _createElementBlock("div", {
          class: "modal-content",
          key: _ctx.formKey
        }, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.$t("company")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onUpsert && _ctx.onUpsert(...args)))
          }, [
            _createElementVNode("div", _hoisted_27, [
              (!_ctx.isUpdate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input me-1",
                            id: "createLegalEntity",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.createLegalEntity) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.form.createLegalEntity]
                          ]),
                          _cache[25] || (_cache[25] = _createElementVNode("label", { for: "createLegalEntity" }, " Create Legal Entity ", -1))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                (!_ctx.form.createLegalEntity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("legalEntity")) + " ", 1),
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _createVNode(_component_ejs_dropdownlist, {
                          enabled: !_ctx.isUpdate,
                          id: "legalEntityDropDown",
                          ref: "legalEntityDropDown",
                          dataSource: _ctx.legalEntities,
                          fields: { text: 'name', value: 'id' },
                          modelValue: _ctx.form.legalEntityId,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.legalEntityId) = $event)),
                          placeholder: _ctx.$t('legalEntity'),
                          popupWidth: "auto",
                          showClearButton: true
                        }, null, 8, ["enabled", "dataSource", "modelValue", "placeholder"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("name")) + " ", 1),
                      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_ejs_textbox, {
                      modelValue: _ctx.form.name,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.name) = $event)),
                      placeholder: _ctx.$t('companyName'),
                      type: "text",
                      id: "companyName"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input me-1",
                        id: "doSync",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.doSync) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.doSync]
                      ]),
                      _cache[28] || (_cache[28] = _createElementVNode("label", { for: "doSync" }, " Enable Syncing ", -1))
                    ])
                  ])
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-6" }, [
                  _createElementVNode("div", { class: "form-group" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('scopes')) + " ", 1),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_CustomTreeView, {
                    ref: "treeView",
                    onNodeCheck: _ctx.nodeChecking,
                    dataSource: _ctx.treeViewData,
                    modelValue: _ctx.scopeTreeSelectedNodes,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scopeTreeSelectedNodes) = $event)),
                    disabledNodes: _ctx.disabledNodes
                  }, null, 8, ["onNodeCheck", "dataSource", "modelValue", "disabledNodes"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-close",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.close()))
              }, [
                _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
                _createTextVNode("  " + _toDisplayString(_ctx.$t("close")), 1)
              ]),
              _createElementVNode("button", _hoisted_45, [
                _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fas fa-save" }, null, -1)),
                _createTextVNode("  " + _toDisplayString(_ctx.isUpdate ? _ctx.$t("update") : _ctx.$t("save")), 1)
              ])
            ])
          ], 32)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "modal-title" }, "Fortnox sync", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeForceSyncModal && _ctx.closeForceSyncModal(...args)))
            }, [...(_cache[33] || (_cache[33] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_ejs_radiobutton, {
                        id: "flexRadioDefault1",
                        value: "full",
                        label: "Full Sync",
                        name: "forceSyncType",
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onForceSyncTypeChange('full'))),
                        checked: _ctx.forceSync.type === 'full'
                      }, null, 8, ["checked"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_ejs_radiobutton, {
                        id: "flexRadioDefault2",
                        value: "custom",
                        label: "Custom Sync",
                        name: "forceSyncType",
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onForceSyncTypeChange('custom'))),
                        checked: _ctx.forceSync.type === 'custom'
                      }, null, 8, ["checked"])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", null, [
                        _createTextVNode("Date: "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_DatePickerComponent, {
                        modelValue: _ctx.forceSync.date,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.forceSync.date) = $event)),
                        format: "yyyy-MM-dd",
                        max: _ctx.today,
                        placeholder: "Select a date to sync from"
                      }, null, 8, ["modelValue", "max"])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.forceSync.type == 'custom']
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_ejs_checkbox, {
                        id: "isSpecificEntities",
                        modelValue: _ctx.forceSync.isSpecificEntities,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.forceSync.isSpecificEntities) = $event)),
                        label: "Specific Entities"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("label", _hoisted_68, [
                        _createTextVNode(_toDisplayString(_ctx.$t('entities')) + " ", 1),
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _createVNode(_component_ejs_multiselect, {
                        id: "entities",
                        modelValue: _ctx.forceSync.entities,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.forceSync.entities) = $event)),
                        dataSource: _ctx.entityLookUp.data,
                        fields: _ctx.entityLookUp.fields,
                        placeholder: _ctx.$t('selectEntity'),
                        popupWidth: "auto",
                        mode: "CheckBox",
                        showClearButton: false,
                        showSelectAll: true
                      }, null, 8, ["modelValue", "dataSource", "fields", "placeholder"])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.forceSync.isSpecificEntities]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-danger",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeForceSyncModal && _ctx.closeForceSyncModal(...args)))
            }, [
              _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
              _createTextVNode("  " + _toDisplayString(_ctx.$t("close")), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.forceSyncByDate())),
              disabled: _ctx.forceSync.type == 'custom' && !_ctx.forceSync.date,
              type: "button",
              class: "btn btn-sm btn-outline-info"
            }, [...(_cache[38] || (_cache[38] = [
              _createElementVNode("i", { class: "fas fa-save" }, null, -1),
              _createTextVNode("  Request Sync ", -1)
            ]))], 8, _hoisted_70)
          ])
        ])
      ])
    ])
  ], 64))
}